import { styled } from "@mui/material";

export const ModalWrapper = styled("div")({
  overflow: "hidden",
});
